import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsNovaChatBotOpen } from "store/AiFeatures/GoalsCreateWithNovaAI/action";
import useApplicationTracker from "customHooks/useApplicationTracker";
import { ReactComponent as NovaChatIcon } from "resources/icons/novachatIcon.svg";
import { useTranslation } from "react-i18next";

const NovaFloatingIcon = ({
  setShowUserMessage,
  setShowNovaChatFromNovaIcon,
}) => {
  const { i18n } = useTranslation();
  const dir = i18n.dir();
  const dispatch = useDispatch();
  const { accountId } = useSelector((state) => state.user);
  const { captureUserEvent } = useApplicationTracker();
  const handleNovaIconClick = () => {
    setShowUserMessage(true);
    setShowNovaChatFromNovaIcon(true);
    dispatch(setIsNovaChatBotOpen(true));
    captureUserEvent("nova_chat_bot_open_from_floating_icon", {
      accountId: accountId,
    });
  };
  return (
    <div
      dir={dir}
      className="cursor-pointer nova-floating-icon"
      onClick={handleNovaIconClick}
    >
      <NovaChatIcon />
    </div>
  );
};

export default NovaFloatingIcon;
